import { render, staticRenderFns } from "./EditableGroupsList.vue?vue&type=template&id=0c55d4a6&scoped=true&"
import script from "./EditableGroupsList.vue?vue&type=script&lang=ts&"
export * from "./EditableGroupsList.vue?vue&type=script&lang=ts&"
import style0 from "./EditableGroupsList.vue?vue&type=style&index=0&id=0c55d4a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c55d4a6",
  null
  
)

export default component.exports